import { render, staticRenderFns } from "./JDInfo.vue?vue&type=template&id=44e08d79&scoped=true&"
import script from "./JDInfo.vue?vue&type=script&lang=js&"
export * from "./JDInfo.vue?vue&type=script&lang=js&"
import style0 from "./JDInfo.vue?vue&type=style&index=0&id=44e08d79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e08d79",
  null
  
)

export default component.exports